import React from 'react';

const DashBoard = () => <div />;
export default DashBoard;
